import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ComingSoon from "../views/ComingSoon.vue";

Vue.use(VueRouter);

const routes = [{
		path: "/",
		name: "Home",
		component: Home
	},
	{
		path: "/nastavnik", 
		name: "Nastavnik", 
		component: () => import('../views/Nastavnik.vue')
	},
	{
		path: "/gsuite", 
		name: "GSuite", 
		component: () => import('../views/GSuite.vue')
	},
	{
		path: "/skolarac", 
		name: "Skolarac", 
		component: () => import('../views/Skolarac.vue')
	},
	{
		path: "/sumtv",
		name: "SumTv",
		component: () => import('../views/SumTV.vue')
	},
	{
		path: "/lekcije",
		name: "Lekcije",
		component: () =>
			import("../views/Lekcije.vue")
	},
	{
		path: "/lekcije/:id",
		name: "RazredLekcije",
		component: () =>
			import("../views/RazredLekcije.vue")
	},
	{
		path: "/novosti",
		name: "PopisNovosti",
		component: () =>
			import("../views/PopisNovosti.vue")
	},
	{
		path: "/edulab",
		name: "EduLab",
		component: () =>
			import("../views/EduLab.vue")
	},
	{
		path: "/predmeti/:type/:grade",
		name: "Predmeti",
		component: () =>
			import("../views/Predmeti.vue")
	},
	{
		path: "/novosti/:alias",
		name: "Novosti",
		component: () =>
			import("../views/Novosti.vue")
	},
	{
		path: "/raspored/:razred?",
		name: "Raspored",
		component: () => import("../views/Raspored.vue"),
	},
	{
		path: "/kontakt", 
		name: "Kontakt", 
		component: () => import('../views/Kontakt.vue')
	},
	{
		path: "/skole", 
		name: "PopisSkola", 
		component: () => import('../views/PopisSkola.vue')
	},
	{
		path: "/pretraga",
		name: "Pretraga",
		component: () => import("../views/PageResults.vue"),
	},
	{
		path: "/dokumenti/:alias",
		name: "Dokumenti",
		component: () => import('../views/ExternalLink.vue')
	},
	{
		path: "/404",
		name: "NotFound",
		component: () => import('../views/NotFound.vue')
	},
	{
		path: '*', 
		redirect: { 
		name: 'NotFound', 
			component: () => import('../views/NotFound.vue')
		}
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior: () => ({
		y: 0
	}),
	routes
});

export default router;
